import { Component } from 'preact';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getOptions, clone, replaceAll, compareDates } from '../../../utilities/common';
import { setTrygTealium } from '../../../utilities/tracking';

// Components
import Label from '../../Form/Label';
import Description from '../../Form/Description';
import { actionHandler } from '../../../utilities/form/formUtils';
import { userDataChangeAction } from '../../../actions/UserData';

class InputSelect extends Component {
  constructor(props) {
    super(props);
    const {
      placeholder,
      loading,
      userData,
      id,
      translations,
    } = props;
    this.state = {
      placeholderState:
        replaceAll(loading, translations, userData) ||
        replaceAll(placeholder, translations, userData),
      value: userData[id] ? userData[id] : '',
      options: [],
    };
  }

  componentDidMount() {
    const {
      initialValues,
      userData,
      dispatch,
      options,
      optionsFrom,
      setFieldValue,
      id,
      setValues,
      textName,
      variant,
      forProduct,
      basketList
    } = this.props;
    if(variant === 'combined' && basketList.length > 1) {
      const arr = [];
      basketList.forEach((item) => {
        arr.push(userData[`activationDateText-${item}`])
      });
      const data = compareDates(arr);
      this.setState({value: data});
    }
    getOptions(
      dispatch,
      options,
      optionsFrom,
      initialValues,
      userData,
      forProduct
    ).then(data => {
      const { placeholderState } = this.state;
      let dataForRender = Array.isArray(data) && data.length > 0 ? data : [];
      if (Array.isArray(data) && data.length > 0 && typeof data[0] !== 'object') {
        dataForRender = data.reduce((result, item) => {
          return [
            ...result,
            {
              key: item,
              value: item,
            },
          ];
        }, []);
      }
      this.setState({
        options: dataForRender,
        placeholderState,
      });

      if (!placeholderState && !this.state.value
        && dataForRender && dataForRender.length > 0) {
        this.state.value = dataForRender[0].key;
        this.setState({
          value: dataForRender[0].key,
        });
      }
      if (setFieldValue && dataForRender && this.state.value) {
        const name = textName || `${[id]}Text`;
        const details = `${[id]}Details`;
        const preSelectedData = dataForRender.reduce((result, item) => {
          return item.key === this.state.value ? item : result;
        }, {});
        if (preSelectedData.key !== undefined) {
          setFieldValue(id, preSelectedData.key);
        } else {
         // This is added because we didn't find the value in the list.
          console.warn('Can\'t find value "' + this.state.value + '" in list.', clone(dataForRender)); // eslint-disable-line
          dataForRender.unshift({
            key: this.state.value,
            value: this.state.value,
          });
        }
        let value = preSelectedData.textValue ? preSelectedData.textValue : preSelectedData.value;
        const monthName = `${[id]}Month`;
        const monthValue =
          Number.isInteger(parseInt(value, 0)) ?
            (value / 12).toFixed(0) :
            0;
        value = value || this.state.value;
        if(variant === 'combined' && basketList.length > 1){
          dispatch(userDataChangeAction(
            {
              fields: [
                {
                  field: `${id}-combined`,
                  value: this.state.value ? this.state.value : dataForRender[0].key,
                },
                {
                  field: `${name}-combined`,
                  value,
                },
                {
                  field: `${monthName}-combined`,
                  value: monthValue,
                },
                {
                  field: `${details}-combined`,
                  value: preSelectedData.details,
                },
              ],
              setValues,
              setFieldValue,
            }
          ));
        }
        else {
          dispatch(userDataChangeAction(
            {
              fields: [
                {
                  field: id,
                  value: this.state.value ? this.state.value : dataForRender[0].key,
                },
                {
                  field: name,
                  value,
                },
                {
                  field: monthName,
                  value: monthValue,
                },
                {
                  field: details,
                  value: preSelectedData.details,
                },
              ],
              setValues,
              setFieldValue,
            }
          ));
        }
      }
    });
  }

  onChangeHandler(event) {
    const {
      id,
      onChange,
      actions,
      dispatch,
      setValues,
      setFieldValue,
      values,
      tealiumMap,
      textName,
      variant,
    } = this.props;
    const name = textName || `${[id]}Text`;
    const monthName = `${[id]}Month`;
    const details = `${[id]}Details`;
    const { options } = this.state;
    const nameValue = options.reduce((result, option) => {
      if (option.key === event.target.value) {
        const value = option.textValue ? option.textValue : option.value;
        setFieldValue(name, value);
        const monthValue =
          Number.isInteger(parseInt(value, 0)) ?
            (value / 12).toFixed(0) :
            0;
        setFieldValue(monthName, monthValue);
        return {
          text: value,
          month: monthValue,
          details: option.details,
          fuelType: option.fuelType,
        };
      }
      return result;
    }, { text: event.target.options[event.target.selectedIndex].text });

    if (tealiumMap) {
      const trackingData = {
        [tealiumMap]: nameValue.text,
      };
      setTrygTealium(trackingData);
    }
    if (actions.length > 0) {
      actionHandler(
        actions,
        onChange,
        event,
        dispatch,
        values,
        setValues,
        {
          [id]: event.target.value,
          [name]: nameValue.text,
          [monthName]: nameValue.month,
          [details]: nameValue.details,
          fuelType: nameValue.fuelType,
        }
      );
    } else {
      onChange(event);
      if(variant === 'combined'){
        setFieldValue(`${id}-combined`, event.target.value);
        setFieldValue(`${name}-combined`, nameValue.text);
        setFieldValue(`${details}-combined`, nameValue.details);
      } else {
        setFieldValue(id, event.target.value);
        setFieldValue(name, nameValue.text);
        setFieldValue(details, nameValue.details);
      }
    }
  }

  render() {
    const {
      id,
      desc,
      label,
      columns,
      formColumns,
      labelColumns,
      className,
      type,
      multiple,
      onBlur,
      required,
      dispatch,
      placeholder,
      labelActions,
      wrapperType: WrapperType,
      translations,
      values,
      setValues,
      hidden,
    } = this.props;
    const { placeholderState, value, options } = this.state;

    const formFieldClass = classNames(
      'form__field', {
        [`form__field--${id}`]: id,
        [`form__field--${type}`]: type,
        [`form__field--${columns}col`]: columns,
        [`form__field--${className}`]: className,
      }
    );
    const formLabelClass = classNames(
      'form__label', {
        [`form__field--${labelColumns}col`]: labelColumns,
        [`form__label--${className}`]: className,
        [`form__${className}`]: className,
      }
    );
    const formElementClass = classNames(
      'form__item', {
        [`form__field--${formColumns}col`]: formColumns,
        [`form__item--${className}`]: className,
        [`form__${className}`]: className,
        [`${className}`]: className,
      }
    );
    const labelProps = {
      actions: labelActions,
      dispatch,
      values,
      setValues,
    };
    if (hidden) {
      return <div />;
    }
    return (
      <WrapperType className={formFieldClass}>

        {/* Label */}
        {label &&
        <Label
          id={id}
          label={label}
          className={formLabelClass}
          {...labelProps}
        />
        }

        {/* Input Field */}
        <select
          className={formElementClass}
          id={id}
          onChange={e => this.onChangeHandler(e)}
          onBlur={onBlur}
          multiple={multiple}
          required={required}
          aria-labelledby={id}
          aria-required={required}
        >
          {((placeholderState && options && options.length === 0) || placeholder) &&
          <option>
            {options && options.length === 0 ?
              placeholderState :
              replaceAll(placeholder, translations, values)
            }
          </option>
          }
          {options && options.map(option => {
            const selected = value === option.key ? 'selected' : '';
            return <option value={option.key} selected={selected}>{option.value}</option>;
          })}
        </select>

        {/* Description */}
        {desc &&
        <Description desc={desc}/>
        }

      </WrapperType>
    );
  }
}

export default compose(
  connect(state => {
    const {
      section: {
        packageData: {
          translations,
        },
      },
    } = state;
    return {
      translations,
    };
  })
)(InputSelect);

InputSelect.defaultProps = {
  desc: null,
  label: null,
  placeholder: null,
  loading: null,
  multiple: false,
  required: false,
  actions: [],
  formColumns: '',
  labelColumns: '',
  className: '',
  labelActions: null,
  wrapperType: 'div',
  tealiumMap: null,
  textName: null,
  hidden: false,
  variant: '',
  basketList: [],
};

InputSelect.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  options: PropTypes.string.isRequired,
  optionsFrom: PropTypes.string.isRequired,
  columns: PropTypes.string.isRequired,
  formColumns: PropTypes.string,
  labelColumns: PropTypes.string,
  userData: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  actions: PropTypes.array,
  required: PropTypes.bool,
  multiple: PropTypes.bool,
  desc: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  loading: PropTypes.string,
  className: PropTypes.string,
  setValues: PropTypes.func.isRequired,
  labelActions: PropTypes.array,
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  wrapperType: PropTypes.string,
  tealiumMap: PropTypes.string,
  translations: PropTypes.object.isRequired,
  textName: PropTypes.string,
  hidden: PropTypes.bool,
  variant: PropTypes.string,
  basketList: PropTypes.array,
};